import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { unstable_composeClasses } from '@mui/base';
import { styled, useThemeProps } from '@mui/material';
import { getLogoUtilityClass } from './logo.classes.js';

const COMPONENT_NAME = 'HublaLogo';
const Size = {
  small: {
    width: '69px',
    height: '16px'
  },
  medium: {
    width: '103px',
    height: '24px'
  },
  large: {
    width: '137px',
    height: '32px'
  }
};
const useUtilityClasses = ownerState => {
  const {
    color,
    size,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${size}`, `${color}`]
  };
  const composedClasses = unstable_composeClasses(slots, getLogoUtilityClass, classes);
  return Object.assign(Object.assign({}, classes), composedClasses);
};
const LogoRoot = styled('svg', {
  name: COMPONENT_NAME,
  slot: 'root',
  shouldForwardProp: prop => prop !== 'ownerState' && prop !== 'classes'
  // @TODO(leandro): uncomment when we figure out how to test it
  // overridesResolver: (props, styles) => {
  //   const { ownerState } = props
  //   return [
  //     styles.root,
  //     styles[`${ownerState.size}`],
  //     ownerState.color === 'primary' && styles.primary,
  //     ownerState.color === 'secondary' && styles.secondary,
  //   ]
  // },
})(({
  theme,
  ownerState
}) => Object.assign(Object.assign({}, ownerState.color && {
  fill: ownerState.color === 'white' ? 'white' : ownerState.color === 'black' ? 'black' : theme.palette[ownerState.color].main
}), ownerState.size && Size[ownerState.size]));
LogoRoot.defaultProps = {
  viewBox: '0 0 855 199'
};
const Logo = inProps => {
  const props = useThemeProps({
    props: inProps,
    name: COMPONENT_NAME
  });
  const {
      color = 'primary',
      size = 'medium',
      className
    } = props,
    other = __rest(props, ["color", "size", "className"]);
  const ownerState = Object.assign(Object.assign({}, props), {
    color,
    size
  });
  const classes = useUtilityClasses(ownerState);
  return jsxs(LogoRoot, Object.assign({
    ownerState: ownerState,
    className: className,
    classes: classes
  }, other, {
    children: [jsx("path", {
      d: "M480.163 94.0332C493.262 84.2686 499.955 71.1578 499.955 54.1397C499.955 38.7915 494.37 25.9478 483.209 15.6221C472.321 5.3031 458.641 0 442.73 0H365.132V195.367H507.489V94.0332H480.163ZM475.393 165.224H397.234V30.1422H442.73C456.964 30.1422 467.852 41.3094 467.852 55.8162C467.852 70.3229 456.964 81.4901 442.73 81.4901H429.33V110.517H475.387V165.224H475.393Z"
    }), jsx("path", {
      d: "M115.839 0H147.942V195.367H115.839V110.804H32.1026V195.373H0V0H32.1026V80.1009H115.839V0Z"
    }), jsx("path", {
      d: "M182.997 0H215.099V128.664C215.099 152.387 229.053 167.736 256.968 167.736C284.882 167.736 298.836 152.387 298.836 128.664V0H330.938V130.621C330.938 151.553 323.958 168.023 310.285 180.579C296.605 192.862 278.743 199 256.968 199C235.198 199 217.33 192.862 203.657 180.579C189.977 168.023 183.003 151.553 183.003 130.621V0H182.997Z"
    }), jsx("path", {
      d: "M573.792 164.67H653.347V195.373H541.689V0H573.792V164.67Z"
    }), jsx("path", {
      d: "M820.386 195.367L806.706 156.014H723.524L709.844 195.367H674.956L745.861 0H784.382L855 195.367H820.386ZM734.138 125.872H796.105L765.125 37.6761L734.138 125.872Z"
    })]
  }));
};

export { Logo };
